import { render, staticRenderFns } from "./paramsScreening.vue?vue&type=template&id=14cfbbf2&scoped=true&"
import script from "./paramsScreening.vue?vue&type=script&lang=js&"
export * from "./paramsScreening.vue?vue&type=script&lang=js&"
import style0 from "./paramsScreening.vue?vue&type=style&index=0&id=14cfbbf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cfbbf2",
  null
  
)

export default component.exports